<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">企业荣誉</div>
    <div class="title-sub">
      企业荣誉是品牌口碑的重要表现形式，企业荣誉是可测量的品牌口碑指标。
    </div>
    <div class="list">
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/1.jpg"></div>
        <div class="name">汽车金融电子票据管理平台</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/2.jpg"></div>
        <div class="name">汽车金融融资管理平台</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/4.jpg"></div>
        <div class="name">橡诺科技金融钱包类开发平台</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/5.jpg"></div>
        <div class="name">橡诺科技金融自动化测试工具</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/6.jpg"></div>
        <div class="name">橡诺汽车联合贷款业务平台软件</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/7.jpg"></div>
        <div class="name">橡诺微信服务号理财超市软件</div>
      </div>
      <!-- <div class="item">
        <div class="pic"><img src="@/assets/img/honor/3.jpg"></div>
        <div class="name">软件企业证书</div>
      </div> -->
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/10.jpg"></div>
        <div class="name">软件企业证书</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/8.png"></div>
        <div class="name">软件企业证书</div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/honor/9.jpg"></div>
        <div class="name">软件企业证书</div>
      </div>
      
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    overflow: visible;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 18px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        width: 1039px;
        height: 48px;
        color: #666666;
        transform: .5s;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
      .list{
        margin-bottom: -20px;
        margin-top: 50px;
        width: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        .item{
          position: relative;
          width: 360px;
          margin-bottom: 50px;
          overflow: visible;
          display: flex;
          flex-direction: center;
          align-items: center;
          padding: 30px;
          background-color: #FFFFFF;
          cursor: pointer;
          box-sizing: border-box;
          .pic{
            position: relative;
            box-sizing: border-box;
            overflow: hidden;
            img{
              width: 100%;
              vertical-align: middle;
            }
            // &::before{
            //   position: absolute;
            //   content: '';
            //   top: 0;
            //   left: 0;
            //   bottom: 0;
            //   width: 100%;
            //   background-color: rgba(0,0,0,.5);
            // }
          }
          .name{
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            color: #fff;
            font-weight: 600;
            font-size: 22px;
            text-align: center;
            box-sizing: border-box;
            z-index: 100;
            display: none;
          }
          .sub{
            position: absolute;
            top: 120px;
            left: 0;
            width: 100%;
            color: #fff;
            font-size: 14px;
            padding: 0 20px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
        .two-item{
          width: 585px;
          height: 225px;
          .sub{
            width: 450px;
            height: 24px;
          }
        }
      }
    }
}
</style>
